<template>
  <x-modal width="500" v-if="createNewTask"
    @close="close"
    @cancel="close"
    @ok="store"
    okText="Create Task">
    <div slot="title" :class="`d-flex justify-content-between align-items-center`">
      Create New Task
    </div>
      <div class="row">
      <div class="col-12">
        <div class="input-belt input-results-dropdown mb-2">
          <label>
            Related To
            <p v-if="selected">{{selected}}</p>
          </label>
          <input
            v-if="!preselect"
            class="form-control"
            v-model="related"
            type="text"
            placeholder="type app ID or contact name"
          >

          <!-- only show if user is searching -->
          <div
            v-if="searchResults.applications && searchResults.applications.length > 0 || searchResults.customers && searchResults.customers.length > 0"
            class="found-results"
          >
            <!-- found application -->
            <label
              class="pt-2 px-2 pb-0"
              v-if="searchResults.applications && searchResults.applications.length > 0"
            >Applications</label>
            <a
              class="pl-4 py-2"
              v-for="application in searchResults.applications"
              :key="`${application.id}-application`"
              @click="chooseRelated(application, 'application')"
            >ID: {{application.id}} - {{application.customer ? application.customer.first_name + ' ' + application.customer.last_name : ''}}</a>
            <!-- dropdown-item -->
            <!-- found contract -->
            <label
              class="pt-2 px-2 pb-0"
              v-if="searchResults.customers && searchResults.customers.length > 0"
            >Customers</label>
            <a
              class="pl-4 py-2"
              v-for="customer in searchResults.customers"
              :key="`${customer.id}-customer`"
              @click="chooseRelated(customer, 'customer')"
            >{{customer.first_name + ' ' + customer.last_name}}</a>
            <!-- dropdown-item -->
          </div>
        </div>

        <div class="input-belt mb-2">
          <label>Task Name</label>
          <input class="form-control" v-model="taskName" type="text">
        </div>
        <div class="row">
          <div class="input-belt mb-2 col-6">
            <label>Due Date</label>
            <el-date-picker
                v-model="dueDate"
                type="date"
                placeholder="Remind me"
                format="dd/MM/yyyy"
                :picker-options="pickerOptions"
            ></el-date-picker>
          </div>

          <div class="input-belt mb-2 col-6">
            <label>Time</label>
            <input class="form-control" v-model="time" type="time">
          </div>
        </div>
        <div class="select-belt mb-2">
          <label>Assign To</label>
          <select class="form-control" v-model="assignUserSelected">
            <option
              v-for="(assignUser) in assignUsersInitial"
              :value="assignUser.id"
              :key="assignUser.id"
            >{{assignUser.first_name}} {{assignUser.last_name}}</option>
          </select>
        </div>
      </div>
    </div>
  </x-modal>

</template>

<script>
import { Message } from "element-ui";
export default {
  name: "NewTaskModal",
  props: ["createNewTask", "tokenInitial"],
  data() {
    return {
      searchResults: {},
      related: "",
      taskName: "",
      taskable_type: "",
      taskable_id: "",
      selected: "",
      assignUserSelected: null,
      dueDate: this.$moment().format("YYYY-MM-DD"),
      preselect: false,
      time: "17:00",
      assignUsersInitial: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 3600 * 1000 * 24;
        },
        shortcuts: [{
          text: 'Today',
          onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: 'Tomorrow',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: 'Next Week',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      },
    };
  },
  watch: {
    related(after, before) {
      if (after.length > 0) {
        this.searchRelatedTo(after);
      } else {
        this.searchResults = {};
      }
    }
  },
  mounted() {
    this.getInitialUser();
    this.applicationId = this.$store.getters.appId;

    if (this.applicationId) {
      this.defaultData({ applicationId: this.applicationId });
    }

    this.getUser();
  },
  methods: {
    close() {
      this.$emit('close', true);
    },
    getUser() {
      axios
        .get("/api/auth", {
          headers: {
            Authorization: "Bearer " + this.tokenInitial
          }
        })
        .then(res => {
          this.assignUserSelected = res.data.id;
        })
        .catch(err => {
          console.error(err);
        });
    },
    async getInitialUser() {
      try {
        let res = await axios.get(`/api/v2/referrers`, {
          headers: {
            Authorization: `Bearer ${this.tokenInitial}`
          }
        });

        this.assignUsersInitial = res.data;
      } catch (err) {
        console.error(err);
      }
    },
    defaultData(data) {
      this.related = data.applicationId;
      this.taskable_id = data.applicationId;
      this.taskable_type = "App\\Models\\Tenant\\Application";

      try {
        let appData = this.$store.getters.initAppData;

        this.selected = `${appData.customer.full_name}` + this.taskable_id;
      } catch (e) {
        this.selected = "Application " + this.taskable_id;
      }
    },
    searchRelatedTo(keyword) {
      axios
        .get("/api/tasks/search-applications-contacts?keyword=" + keyword, {
          headers: {
            Authorization: "Bearer " + this.tokenInitial
          }
        })

        .then(response => {
          this.searchResults = response.data;
        })
        .catch(error => {});
    },
    chooseRelated(item, type) {
      if (type === "application") {
        this.taskable_type = "App\\Models\\Tenant\\Application";
        this.selected = `${item.customer.full_name} ${item.id}`;
      } else if (type === "customer") {
        this.taskable_type = "App\\Models\\Auth\\User";
        this.selected = "Contact " + item.first_name;
      }
      this.taskable_id = item.id;
      this.related = "";
    },
    store() {
      axios
        .post(
          "/api/tasks",
          {
            taskable_type: this.taskable_type,
            taskable_id: this.taskable_id,
            task_name: this.taskName,
            broker_id: this.assignUserSelected,
            due_date: this.$moment(this.dueDate).format('YYYY-MM-DD'),
            time: this.time
          },
          {
            headers: {
              Authorization: "Bearer " + this.tokenInitial
            }
          }
        )
        .then(response => {
          if (response.data.id) {
            Message({
              message: "Task created successfully.",
              type: "success"
            });
            this.$emit("close", true);
            this.$bus.$emit("refresh-tasks-table", "");
            this.fresh();
          }
        })
        .catch(error => {
          Message({
            message: error.error.message,
            type: "error"
          });
        });
    },
    fresh() {
      this.searchResults = {};
      this.related = "";
      this.taskName = "";
      this.phone = "";
      this.email = "";
      this.assignUserSelected = null;
    }
  }
};
</script>

<style scoped>
</style>
